export default __webpack_public_path__ + "static/media/triangle-active.ac854f5b.png";